"use strict";
import { jsx } from "react/jsx-runtime";
import DragPoint from "./drag_point";
import { getDisplayName } from "./utils";
export default (AnnotationComponent) => {
  const DragPoints = ({
    dragPoints,
    hovered = false,
    hoveredDragPointIndex
  }) => {
    let dragPointViews = null;
    if (hovered) {
      dragPointViews = dragPoints.map((dragPoint, i) => {
        return /* @__PURE__ */ jsx(
          DragPoint,
          {
            position: dragPoint,
            hovered: hoveredDragPointIndex === i
          },
          i
        );
      });
    }
    return /* @__PURE__ */ jsx("g", { children: dragPointViews });
  };
  DragPoints.displayName = `DragPointsFor(${getDisplayName(AnnotationComponent)})`;
  return DragPoints;
};
